import React from "react";

import TermsTemplate from "@components/termsPage/termsTemplate";
import Layout from '@components/layout';

const IndexPage = ({ pageContext }) => (
  <Layout locale={pageContext.locale}>
    <TermsTemplate pageContext={pageContext} />
  </Layout>
);

export default IndexPage;
